export const colors = {
  // Basic Colors
  white: "#FFFFFF",
  black: "#000000",
  primary: "#212121",
};
